/* 
  Rebuy Smart Cart – bundle child price masker
  -------------------------------------------------
  What it does:
  - Watches the Rebuy cart DOM (#rebuy-cart)
  - Sets the visible price of bundle *child* lines to $0.00
    (child = has bundle_id but NOT bundle_parent:true)
  - Optionally recalculates the visible subtotal to exclude
    child lines (to avoid double counting in UI)
  Notes:
  - This only affects the cart UI. Checkout pricing is still 
    handled server-side by StayAI.
*/

(function () {
  var MONEY_LOCALE = 'en-US';

  function formatMoney(cents) {
    try {
      var cur =
        (window.Shopify && Shopify.currency && Shopify.currency.active) ||
        'USD';
      return (cents / 100).toLocaleString(MONEY_LOCALE, {
        style: 'currency',
        currency: cur,
      });
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  // True if the <li> looks like a bundle child in Rebuy
  function isBundleChildLI(li) {
    if (!li) return false;
    var cls = li.className || '';
    // Rebuy adds classes like:
    //  "property-key-bundle_id property-bundle_id:<uuid> ..."
    var hasBundleId =
      cls.indexOf('property-key-bundle_id') !== -1 ||
      cls.indexOf('property-bundle_id:') !== -1;
    var isParent =
      cls.indexOf('property-bundle_parent:true') !== -1 ||
      cls.indexOf('property-key-bundle_parent') !== -1;
    return hasBundleId && !isParent;
  }

  // Force $0.00 on a Rebuy line item
  function zeroOutRebuyLine(li) {
    try {
      // Sale price node
      var saleAmount = li.querySelector(
        '.rebuy-cart__flyout-item-price .rebuy-money.sale span:not(.sr-only)'
      );
      if (saleAmount) saleAmount.textContent = formatMoney(0);

      // Hide compare-at price if present
      var compareWrap = li.querySelector(
        '.rebuy-cart__flyout-item-price .rebuy-money.compare-at'
      );
      if (compareWrap) compareWrap.style.display = 'none';

      // Optional: add a subtle note
      if (!li.querySelector('[data-bundle-note]')) {
        var note = document.createElement('div');
        note.setAttribute('data-bundle-note', 'true');
        note.style.fontSize = '12px';
        note.style.opacity = '0.7';
        note.style.marginTop = '2px';
        note.textContent = 'Included in bundle';
        var info = li.querySelector('.rebuy-cart__flyout-item-info');
        if (info) info.appendChild(note);
      }
    } catch (e) {
      /* noop */
    }
  }

  // Recompute subtotal shown in Rebuy footer using /cart.js
  function recomputeSubtotalUI() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (!cart || !cart.items) return;

        var maskedSubtotal = 0;
        for (var i = 0; i < cart.items.length; i++) {
          var it = cart.items[i];
          var props = it.properties || {};
          var isChild = !!(props.bundle_id && !props.bundle_parent);
          if (!isChild) maskedSubtotal += it.line_price || 0;
        }

        // Update the visible subtotal in Rebuy
        var subNode = document.querySelector(
          '.rebuy-cart__flyout-subtotal-final-amount span:not(.sr-only)'
        );
        if (subNode) subNode.textContent = formatMoney(maskedSubtotal);
      })
      .catch(function () {
        /* ignore */
      });
  }

  // Run mask across the current Rebuy cart DOM
  function applyMask() {
    var cart = document.getElementById('rebuy-cart');
    if (!cart) return;

    // Zero-out every bundle child line
    var items = cart.querySelectorAll('.rebuy-cart__flyout-item');
    Array.prototype.forEach.call(items, function (li) {
      if (isBundleChildLI(li)) zeroOutRebuyLine(li);
    });

    // Subtotal fix (UI only)
    recomputeSubtotalUI();
  }

  // Debounce helper
  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this,
        args = arguments;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait || 120);
    };
  }

  // Observe changes under #rebuy-cart and re-apply the mask
  function observeRebuy() {
    var cart = document.getElementById('rebuy-cart');
    if (!cart || !window.MutationObserver) return;

    var runner = debounce(applyMask, 100);

    var obs = new MutationObserver(function () {
      runner();
    });

    obs.observe(cart, {
      childList: true,
      subtree: true,
    });

    // First pass
    applyMask();
  }

  // Init on DOM ready and when Rebuy mounts later
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeRebuy);
  } else {
    observeRebuy();
  }

  // Some themes load Rebuy after window load — ensure we try again
  window.addEventListener('load', observeRebuy);
})();
